// SF 監査タブの共通プレースホルダ。サンプル（モック）データは一切表示せず、
// 未接続なら連携画面への誘導ボタン、取得失敗なら再試行ボタンを出す（mock honesty）。
import type { SfSection } from "./sections";

// Salesforce 未接続時のプレースホルダ。連携画面（接続タブ）へ遷移するボタンを表示する。
export function renderNotConnected(
  panel: HTMLElement,
  onNavigate: (section: SfSection) => void,
): void {
  panel.replaceChildren();

  const card = document.createElement("div");
  card.className = "rounded-lg border border-slate-200 bg-white p-8 text-center";

  const title = document.createElement("h2");
  title.className = "text-base font-semibold text-slate-900";
  title.textContent = "Salesforce が未接続です";

  const desc = document.createElement("p");
  desc.className = "mx-auto mt-2 max-w-md text-sm text-slate-600";
  desc.textContent = "監査データを表示するには、まず Salesforce 組織と接続してください。";

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className =
    "mt-5 inline-flex items-center rounded bg-shinonome-700 px-4 py-2 text-sm font-medium text-white hover:bg-shinonome-800";
  btn.textContent = "Salesforce と接続";
  btn.addEventListener("click", () => onNavigate("connect"));

  card.append(title, desc, btn);
  panel.append(card);
}

// 読み込み失敗時のプレースホルダ。サンプルにフォールバックせず、再試行ボタンを出す。
export function renderLoadError(panel: HTMLElement, onRetry: () => void): void {
  panel.replaceChildren();

  const card = document.createElement("div");
  card.className = "rounded-lg border border-red-200 bg-red-50 p-8 text-center";

  const title = document.createElement("h2");
  title.className = "text-base font-semibold text-red-800";
  title.textContent = "読み込みに失敗しました";

  const desc = document.createElement("p");
  desc.className = "mx-auto mt-2 max-w-md text-sm text-red-700";
  desc.textContent = "データの取得中にエラーが発生しました。時間をおいて再度お試しください。";

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className =
    "mt-5 inline-flex items-center rounded border border-red-300 bg-white px-4 py-2 text-sm font-medium text-red-700 hover:bg-red-100";
  btn.textContent = "再試行";
  btn.addEventListener("click", onRetry);

  card.append(title, desc, btn);
  panel.append(card);
}
